<template>
	<joy-page :joyPageStatus="joyPageStatus">
		<div class="paddingbottom50">
			<van-field
			   v-model="listData.bank"
			   clearable
			   label="开户银行"
			   placeholder="请输入开户银行"
			 />
			<van-field
			   v-model="listData.bank_account"
			   type="number"
			   clearable
			   label="银行卡号"
			   placeholder="请输入银行卡号"
			 />
		</div>
		<div class="fixBottom">
			<van-button  @click="save" type="info" size="large">保存</van-button>
		</div>
	</joy-page>
</template>

<script>
	export default{
		created() {
			this.loadData();
		},
		data(){
			return{
				joyPageStatus:'',
				listData:'',
			}
		},
		methods:{
			save(){
				const that=this;
				if(that.listData.bank=="" || that.listData.bank==null){
					that.$dialog.alert({
					  message: '开户银行不能为空'
					});
				}else if(that.listData.bank_account=="" || that.listData.bank_account==null){
					that.$dialog.alert({
					  message: '银行卡号不能为空'
					});
				}else{
					let query={
						"bank":that.listData.bank,
						"bank_account":that.listData.bank_account,
					};
					try{
						that.$axios.post('user/update2',query).then(res => {
							if(res.data.code==200){
								that.$toast.success('保存成功');
								setTimeout(function() {
										that.$router.go(-1)
								}, 1000);
							}else{
								that.$toast.fail(res.data.msg)
							}
						})
					}catch(e){
						if (this.$mConfig.debug) {
							console.log(e);
						};
					}
				}
			},
			loadData(){
				try{
					this.joyPageStatus = 'loading';
					this.$axios.get('user/info').then(res => {
						this.joyPageStatus = 'success';
						if(res.data.code==200){
							this.listData=res.data.data;
						}else{
							this.$toast.fail(res.data.msg)
						}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		},
		
	}
	
</script>

<style scoped="scoped">
</style>
